import styled from 'styled-components'

export const Price = styled.strong`
  display: block;
  white-space: nowrap;
  font-weight: ${props => (props.isHorizontal ? '700' : '500')};
  font-size: ${props => (props.isHorizontal ? '32px' : '16px')};
  line-height: ${props => !props.isHorizontal && '150%'};
  margin-bottom: ${props => (props.isHorizontal ? '0' : '5px')};
  padding: ${props => (props.isHorizontal ? '0 50px' : '0 16px')};
  color: #000;
`
